/**
 * Check if content has valid text
 * @param {Object} content - Content object
 * @returns {boolean} Whether content has valid text
 */
export const hasValidText = (content) => {
  if (!content) return false
  return content.text && content.text.trim().length > 0
}

/**
 * Get platform names as a string
 * @param {Array} platforms - Array of platform objects or IDs
 * @returns {string} Platform names
 */
export const getPlatformNames = (platforms) => {
  if (!platforms || !platforms.length) return ''
  
  const platformMap = {
    1: 'Instagram',
    2: 'Facebook',
    3: 'TwitterX',
  }
  
  return platforms.map(platform => {
    const id = typeof platform === 'object' ? platform.id : platform
    return platformMap[id] || 'Unknown'
  }).join(', ')
}

/**
 * Extract hashtags from content text
 * @param {string} text - Content text
 * @returns {Array} Array of hashtag strings
 */
export const extractHashtags = (text) => {
  if (!text) return []
  
  const hashtagRegex = /#(\w+)/g
  const matches = text.match(hashtagRegex)
  
  if (!matches) return []
  
  return matches.map(tag => tag.trim())
}

/**
 * Check if media is a video
 * @param {Object} media - Media object
 * @returns {boolean} Whether media is a video
 */
export const isVideo = (media) => {
  if (!media) return false

  if (media.type && media.type.includes('video')) {
    return true
  }

  // Check if URL ends with common video extensions
  const url = media.url || media.preview || ''
  const videoExtensions = ['.mp4', '.mov', '.avi', '.webm', '.mkv', '.flv', '.wmv']
  return videoExtensions.some(ext => url.toLowerCase().endsWith(ext))
}

// Export all functions as a named object
export const contentUtils = {
  hasValidText,
  getPlatformNames,
  extractHashtags,
  isVideo
}
